// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer[data-v-889a21c4]{bottom:20px}.main-body[data-v-889a21c4]{min-height:600px}.signature[data-v-889a21c4]{border:1px solid;border-radius:4px}h1[data-v-889a21c4]{font-size:18px}h2[data-v-889a21c4]{font-size:14px}h3[data-v-889a21c4]{font-size:12px}.pdf[data-v-889a21c4]{font-size:10px;width:595px;background-color:#fff;margin:0 auto;padding:12px}.bordered[data-v-889a21c4]{border-top:1px solid;border-bottom:1px solid}", ""]);
// Exports
module.exports = exports;
